import {
	defAction
}from "../../../helpers/defaultAction"
import downloadFile from "../../../helpers/downloadFile"
import api from './api'
import {
	reConstructionMaterialPeriodPricesConstants
}from "./constants"

export const reConstructionMaterialPeriodPriceActions = {
	getPaged,
	upload,
	getExampleFile,
	clear
}

function clear(){
	return (dispatch) => dispatch({
		type: reConstructionMaterialPeriodPricesConstants.CLEAR
	})
}

function upload(values){
	const dispatchObj = {
		constants : reConstructionMaterialPeriodPricesConstants.Upload,
		service   : {
			func   : api.uploadPrices,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getExampleFile(){
	const dispatchObj = {
		constants : reConstructionMaterialPeriodPricesConstants.GetExampleFile,
		service   : {
			func: api.getExampleFile
		},
		sucFunction: (res) => downloadFile(res, "Шаблон.xlsx")
	}
	return defAction(dispatchObj)
}

function getPaged(values){
	const dispatchObj = {
		constants : reConstructionMaterialPeriodPricesConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}